import { render, staticRenderFns } from "./BoxMenuList.vue?vue&type=template&id=1f82e70e&scoped=true&"
import script from "./BoxMenuList.vue?vue&type=script&lang=js&"
export * from "./BoxMenuList.vue?vue&type=script&lang=js&"
import style0 from "./BoxMenuList.vue?vue&type=style&index=0&id=1f82e70e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f82e70e",
  null
  
)

export default component.exports